import { FC, useEffect, useRef } from 'react';
import { Radio, RadioProps } from '@chakra-ui/react';

export const ChakraRadio: FC<RadioProps> = ({ isChecked, ...rest }) => {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (ref.current) {
      if (isChecked) {
        ref.current.setAttribute('checked', '');
      } else {
        ref.current.removeAttribute('checked');
      }
    }
  }, [isChecked]);

  return <Radio isChecked={isChecked} ref={ref} {...rest} />;
};
